<!--<div class="pagebrk"></div>
  <printheaderview>
  </printheaderview>-->
<div class="pagebrk">
  <div class="row">
    <div class="col-print-12 padding-left-0px">
      <div class="card">
        <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

          <div class="row">
            <div class="col-print-12 text-align-center">
              <label class="font-familyhead">Services List</label>
            </div>
          </div>

          <div class="row bordertop border-bot-1px margin-left-0px margin-right-0px margin-bottom-10px">
            <div class="col-print-6 margin-top-10">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{CustomerName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{AgeY}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Order Code:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{OrderNo}}</label>
                </div>
              </div>

            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">{{FormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Mobile No:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">{{MobileNumber}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Order Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">{{OrderDate | date:'MMM-dd-yyyy'}}</label>
                </div>
              </div>

            </div>

            <div class="col-print-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-3">
                  <label class="margin-bottom-0px font-family font-weight-normal">Address:</label>
                </div>
                <div class="col-print-9">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DeliverToAddress}}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="row margin-left-0px margin-right-0px">

            <div class="col-print-12">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-12">
                  <div class="table-component margin-bottom-0px">
                    <div class="table-responsive">
                      <table class="table table-striped margin-left-zero border4">
                        <tr>

                          <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                            #
                          </th>
                          <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                            Service Name
                          </th>
                          <!--<th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                            QTY
                          </th>-->
                          <!--<th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                            Pack
                          </th>-->
                          <!--<th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                            Unit Price
                          </th>-->
                          <!--<th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                            UOM
                          </th>
                          <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                            Issue QTY
                          </th>-->
                          <!--<th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                            Amount
                          </th>-->
                          <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                            Comments
                          </th>

                        </tr>
                        <tr *ngFor="let l of pdata;let RowIndex = index">
                          <td class="font-family padding-top-2px padding-bottom-2px">{{RowIndex+1}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px">{{l.ItemName}}</td>
                          <!--<td class="font-family padding-top-2px padding-bottom-2px">{{l.Quantity}}</td>-->
                          <!--<td class="font-family padding-top-2px padding-bottom-2px">New</td>-->
                          <!--<td class="font-family padding-top-2px padding-bottom-2px">{{l.UnitPrice}}</td>-->
                          <!--<td class="font-family padding-top-2px padding-bottom-2px">3</td>
                          <td class="font-family padding-top-2px padding-bottom-2px">3</td>-->
                          <!--<td class="font-family padding-top-2px padding-bottom-2px">{{l.Quantity * l.UnitPrice}}</td>-->
                          <td class="font-family padding-top-2px padding-bottom-2px">{{l.Comments}}</td>

                        </tr>

                      </table>

                    </div>
                  </div>
                </div>
              </div>

              <!--<div class="row margin-top-5px margin-bottom-5px margin-left-0px margin-right-0px">
                <div class="col-print-9">

                </div>
                <div class="col-print-3">
                  <div class="row margin-left-0px margin-right-0px">

                    <div class="col-print-12">
                      <label class="font-weight-normal font-family margin-bottom-0px text-align-right">Total Value: {{TotalAmount}}</label>
                    </div>

                  </div>
                </div>
              </div>-->
            </div>
          </div>



        </div>
      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
